import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals } from '../../../../Fct/generics';
import { getPairs } from '../helpers/pairs';
export var DataFeedDecimals = createPlugin({
    protocol: 'CHAINLINK',
    type: 'ORACLE',
    method: 'decimals',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'chainlink_datafeed', options: getPairs({ chainId: chainId }) }),
                methodParams: {},
            },
            output: {
                decimals: new FctDecimals({ innerIndex: 0 }),
            },
        });
    },
});
